/* eslint-disable import/prefer-default-export */
import Benefits from '../../api/Benefits';
import BasicNotification from '../../shared/components/Notifications/BasicNotification';
import {
  GET_BENEFITS_REQUEST,
  GET_BENEFITS_SUCCESS,
  GET_BENEFITS_FAILURE,
} from '../../api/Types';

export const getBenefits = () => async (dispatch) => {
  dispatch({ type: GET_BENEFITS_REQUEST });
  try {
    const { body } = await Benefits.get();
    dispatch({ type: GET_BENEFITS_SUCCESS, body });
  } catch (error) {
    dispatch({ type: GET_BENEFITS_FAILURE, error });
    BasicNotification.error('Ocurrió un error al intentar obtener los beneficios.');
  }
};
